import { RailStoreV2, TopAssetsStore } from '@kaltura-ott/tvpil-shared';

export function checkIsTopRail(rail: RailStoreV2) {
  return rail instanceof TopAssetsStore;
}
